<script setup lang="ts">
import { computed } from 'vue'
import { POS_SSO_URL, reasonText, type SignedOutReason } from '../api/session'
import Icon from './ui/Icon.vue'

const props = defineProps<{ reason: SignedOutReason; failed?: boolean }>()
const emit = defineEmits<{ retry: [] }>()

const line = computed(() => (props.failed ? 'ตรวจอินเทอร์เน็ต แล้วลองอีกครั้ง' : reasonText(props.reason)))
</script>

<template>
  <main class="gate">
    <section class="card" aria-labelledby="gate-title">
      <div class="mark" aria-hidden="true"><Icon name="chat" /></div>
      <h1 v-if="failed" id="gate-title">ต่อเซิร์ฟเวอร์แชทไม่ได้</h1>
      <h1 v-else id="gate-title">เข้าระบบแชทผ่านเมนู <span class="menu">แชทรวม</span> ใน POS</h1>
      <p class="line" role="status">{{ line }}</p>
      <button v-if="failed" class="go" type="button" @click="emit('retry')">ลองอีกครั้ง</button>
      <a v-else class="go" :href="POS_SSO_URL">
        เข้าผ่าน POS
        <Icon name="arrowRight" />
      </a>
      <p v-if="!failed" class="note">ถ้า POS ให้เข้าระบบก่อน เข้าแล้วกดเมนู แชทรวม อีกครั้ง</p>
    </section>
  </main>
</template>

<style scoped>
.gate {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: var(--bg);
}
.card {
  width: 100%;
  max-width: 440px;
  background: var(--sf);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 32px 32px 28px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(23, 33, 28, 0.04);
}
.mark {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  border-radius: 14px;
  background: var(--acs);
  color: var(--ac);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mark :deep(.ic) {
  width: 24px;
  height: 24px;
}
h1 {
  font-size: 19px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--ink);
  text-wrap: balance;
}
h1 .menu {
  color: var(--ac);
}
.line {
  text-wrap: balance;
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--mut);
}
.go {
  margin-top: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 180px;
  height: 44px;
  padding: 0 20px;
  border-radius: 10px;
  background: var(--ac);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none;
}
.go:hover {
  background: var(--ac2);
}
.go :deep(.ic) {
  width: 18px;
  height: 18px;
}
.note {
  text-wrap: balance;
  margin-top: 16px;
  font-size: 12.5px;
  line-height: 1.6;
  color: var(--mut);
}
</style>
